module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-05-711ffa03c178644f58538d879d5a1e1e.png";